module.exports = __webpack_public_path__ + "static/media/light-snow.d3e48215.svg";